import { Component, Input, OnInit } from '@angular/core';
import { Tag } from 'src/app/shared/models/general/tag';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
})
export class TagsComponent implements OnInit {
  @Input() Tags: Tag[] = [];
  @Input() ExcludedTagIds: number[] = [];

  constructor(private datePipe: DatePipe) {}

  ngOnInit(): void {}

  getColourClass(colour: string): string {
    return `badge-${colour}`;
  }

  dateAwareTagIds: number[] = [Tag.Id.WITHDRAWAL, Tag.Id.DEPOSIT_DETECTED];

  getFilteredTags(): Tag[] {
    return this.Tags.filter((tag) => !this.ExcludedTagIds.includes(tag.id));
  }

  generateTagName(tag: Tag): string {
    let displayName = tag.name;

    if (!this.dateAwareTagIds.includes(tag.id)) {
      return displayName;
    }

    if (!tag.dateTimeUpdated) {
      return displayName;
    }

    const formattedDate = this.datePipe.transform(tag.dateTimeUpdated, 'dd-MMM HH:mm');
    displayName = `${displayName} ${formattedDate}`;

    return displayName;
  }
}
